import type { FaireProductEntity } from "../../entity_types/product";

export const p_kuzb5h8zh4: FaireProductEntity = {
  token: "p_kuzb5h8zh4",
  type: "product",
  name: "Hand-loomed Beige Laurette Shawl, Undyed Alpaca",
  brandToken: "b_b067eaumjh",
  brandName: "Happy French Gang",
  imageUrl:
    "https://cdn.faire.com/fastly/fcd4c822932491c76ce0e62de46b824c5a3a88c2845267469b6ad4be201174d5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1c6e94df518b7d7b5b6ee40f15226c168e391f57342b2e789b2b21288380cc3.jpeg",
    "https://cdn.faire.com/fastly/da595f9decfdaf5237d02344941dea8e07bf039aec634fd2924b9f617afe442e.jpeg",
    "https://cdn.faire.com/fastly/ae19b13366c63df1bac816491b98cac9df5ec913bfeb4d6477f808e57e7a5999.jpeg",
    "https://cdn.faire.com/fastly/f881de62d039c5c81ddea03cd5a70b723b914ec37aa236fc85ceddabd6dd84ce.jpeg",
    "https://cdn.faire.com/fastly/38ddc1081c8df9277e1f070e4c62dff5544c5c01d4be6ec8783d88566112da3e.jpeg",
    "https://cdn.faire.com/fastly/88080d53aa54940c22e92c0bd5e5b3118958652fe3cf08ae5aeddb4b744d7ebc.jpeg",
    "https://cdn.faire.com/fastly/71feca1097205fca311ed5339a60e9d92817d6e5718bb7432e5735bfddd2db13.jpeg",
  ],
  priceDollars: 99,
  description:
    "Our Laurette show is made out of 68% Alpaca, 32% Pima Organic Cotton. It is a very soft yarn that is hand loomed. Our yarn is undyed and this garment is produced in Peru. \n\nCare: To maintain its beauty, hand wash in lukewarm water or machine wash cold on wool program using mild detergent. Do not soak. Lay flat to dry and store folded. \n\nBy choosing our shawl, you support sustainable fashion and enjoy a one-of-a-kind, handmade garment. Add this exquisite shawl to your wardrobe today.\n",
  tags: [],
  msrpDollars: 198,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:54.242Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
